export default __webpack_public_path__ + "static/logo-10b978d2a6deb1ace957aac2090fe04b.png";